import { zoraCreator1155FactoryImplConfig } from '@zoralabs/protocol-deployments'

const { abi, address } = zoraCreator1155FactoryImplConfig

export const ZoraCreator1155FactoryImpl = {
  abi,
  address,
} as const
